import React from 'react';
import { Card, CardHeader, CardBody, Col, Row,  } from 'reactstrap';
import '../App.css';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

class Comments extends React.Component {
    constructor(props){
      super(props);
  
      this.state = {
        name: '',
        comments: "",
      }; 
    } 

    handleChange = (event) =>{
      //this.setState({comments: event.target.value});
      this.props.app.setState({comments: event.target.value});
    }


 
    render() {

      let info = null;

      let comments = this.props.app.state.comments;

      let container1 = {
        padding: "3px",
        margin: "3px",
        width: "fit-content",
        borderRadius: "4px",
        backgroundColor: "#dadada"
      }

      let textf = {
        width: "50px",
        border: '0px',
        borderRadius: '4px',
        textAlign: 'center',
        fontFamily: 'sans-serif',
        fontSize:"13.5px"
      }

      let btn = {
        height: '18px',
        display: 'block',
      }

        info = (
          <Card className='card'  style={{boxShadow:'rgba(0, 0, 0, 0.2) 0px 8px 12px 0px, rgba(0, 0, 0, 0.2) 0px 6px 12px 0px'}}>
          <CardHeader className='cardheadr' >Image Comments</CardHeader>
          <CardBody className='cardbody'>

            <Grid container direction="column" justify="center" alignItems="center" style={{padding:'5px'}}>

              <TextField
                id="filled-dense-multiline"
                style={{marginTop:"0px"}}
                type="text"
                rows="3"
                fullWidth
                variant="outlined"
                multiline
                rowsMax="3"
                value = {comments}
                onChange = {this.handleChange}
              />

           </Grid>

          </CardBody>
          </Card>   
        );

      return (
        <div>
        {info}
        </div>
      );
    }
  }
  
  export default Comments;